import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ExtinguisherIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M6.5 3.50947C4.82189 3.63713 3.5 5.03919 3.5 6.75V12.75C3.5 13.1642 3.16421 13.5 2.75 13.5C2.33579 13.5 2 13.1642 2 12.75V6.75C2 4.18209 4.03771 2.09011 6.58435 2.00283C6.78947 1.41876 7.34583 1 8 1C8.80422 1 9.46062 1.6329 9.49829 2.4278L13.1746 1.04115C13.5699 0.892032 14 1.16659 14 1.5681V4.4319C14 4.83341 13.5699 5.10797 13.1746 4.95885L9.5 3.57284V4.40135C10.3967 4.92006 11 5.88958 11 7V10.5H5V7C5 5.88958 5.6033 4.92006 6.5 4.40135V3.50947Z"
			></path>
			<path
				fill="currentColor"
				d="M5 14.5V13H11V14.5C11 14.7761 10.7761 15 10.5 15H5.5C5.22386 15 5 14.7761 5 14.5Z"
			></path>
		</svg>
	),
)
